import { api } from './api';
import type { ApiResponse } from '../types';
import type { EventRsvp, EventRsvpWithUser, SubmitRsvpInput, RsvpStats } from '../types/rsvp';

export interface RsvpResponse {
  rsvp: EventRsvp;
}

export interface MyRsvpResponse {
  rsvp: EventRsvp | null;
}

export interface EventRsvpsResponse {
  rsvps: EventRsvpWithUser[];
  stats: RsvpStats;
}

export interface RsvpStatsResponse {
  stats: RsvpStats;
}

export const rsvpService = {
  async submitRsvp(data: SubmitRsvpInput): Promise<RsvpResponse> {
    const response = await api.post<ApiResponse<RsvpResponse>>('/rsvp', data);
    return response.data!;
  },

  async getMyRsvp(eventId: string): Promise<MyRsvpResponse> {
    const response = await api.get<ApiResponse<MyRsvpResponse>>(`/rsvp/my/${eventId}`);
    return response.data!;
  },

  async deleteMyRsvp(eventId: string): Promise<void> {
    await api.delete<ApiResponse<void>>(`/rsvp/${eventId}`);
  },

  async getEventRsvps(eventId: string): Promise<EventRsvpsResponse> {
    const response = await api.get<ApiResponse<EventRsvpsResponse>>(`/admin/rsvp/${eventId}`);
    return response.data!;
  },

  async getRsvpStats(eventId: string): Promise<RsvpStatsResponse> {
    const response = await api.get<ApiResponse<RsvpStatsResponse>>(`/admin/rsvp/${eventId}/stats`);
    return response.data!;
  },
};
